import React from 'react';
import PropTypes from 'prop-types';
import {
  ListItemIcon,
  MenuItem,
  Typography,
} from '@mui/material';
import { STYLE_OPTIONS } from 'src/constants';

const menuItemStyle = {
  '& .MuiListItemIcon-root': {
    minWidth: '24px',
  },
  '& .MuiListItemIcon, & svg': {
    color: '#B5B5B5',
  },
  '&:hover': {
    color: STYLE_OPTIONS.SVG_COLOR_BLUE,
    '& .MuiListItemIcon, & svg': {
      color: STYLE_OPTIONS.SVG_COLOR_BLUE,
    },
  },
};

function ActionMenuItem({ icon, label, ...props }) {
  return (
    <MenuItem
      sx={{
        ...menuItemStyle,
      }}
      {...props}
    >
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <Typography variant="body2">
        {label}
      </Typography>
    </MenuItem>
  );
}

ActionMenuItem.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string,
};

ActionMenuItem.defaultProps = {
  icon: null,
  label: '',
};

export default ActionMenuItem;
